
import React from 'react';

export const PythonW3C= () => {
	return ( <div>
		<br />
		<h4>Python Tutorial</h4>
		<h5>Summary: Create basic Python applications</h5>
		<h5>Prerequisites: Windows 10 or MacOS, and Python</h5>
					
		<p>Instructions: Complete the Python <a href='https://www.w3schools.com/python/'>tutorial</a> from W3C </p>
		<ul style={{ listStyleType:'square' }}>
			<li>Part 1 of begins with the “Python Home” section ends with the “Python Functions” section</li>
			<li>Part 2 includes only the following Python tutorial sections:</li>
			<ul style={{ listStyleType:'square' }}>
				<li>Python Arrays</li>
				<li>Python User Input</li>
				<li>Python String Formatting</li>
			</ul>
			<li>Part 3 includes only the following Python tutorial sections:</li>
			<ul style={{ listStyleType:'square' }}>
				<li>Dates</li>
				<li>Math</li>
				<li>JSON</li>
				<li>PIP</li>
			</ul>
		</ul>
		<p>Be sure to review the “Python Examples” section at the bottom of the tutorial. The examples section provides 
		excellent additional information and sample code from each of the sections listed above.</p>

		<p>You should follow along and complete the steps yourself. As you go through the tutorial, you will need to make the 
		resulting application uniquely your own by adding standard comments at the top application (i.e. your name, class, etc.), 
		changing the names of variables, and adding small features.</p>

		<p>Be sure to save your work so that you can submit it as part of an assignment.</p>

	</div> )
}